<mycampapp-header (orgChanging)="headerLoading = $event" (aiSelected)="handleAIChanging()"></mycampapp-header>

<p-toast position="bottom-right" [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}" [style]="{width: '40vw'}"></p-toast>

<div *ngIf="!headerLoading" class="content-container">
    <router-outlet></router-outlet>
</div>

<p-confirmDialog></p-confirmDialog>
<p-confirmPopup key="popup"></p-confirmPopup>
<mycampapp-ai-assistant *ngIf="aiVisible" (closed)="aiVisible = false"></mycampapp-ai-assistant>
